
export default () => {
    const sidebarToggle = document.querySelector(".sidebar-toggle");
    const sidebar = document.querySelector("#wrapper .sidebar");
    const hamburger = document.querySelector("#wrapper .hamburger");
    const notificationButton = document.querySelector("#wrapper .notifications .btn")
    const notificationContainer = "#wrapper .notifications-container";
    const basketButton = document.querySelector("#wrapper .btn-link.basket")
    const basketContainer = "#wrapper .basket-container";

    if (sidebarToggle) {
        sidebarToggle.addEventListener("click", (e) => {
            if (sidebar) {
                sidebar.classList.toggle("sidebar--closed");
            }
        });
    }

    if (hamburger && sidebar) {
        hamburger.addEventListener("click", (e) => {
            sidebar.classList.toggle("hamburger--open");
            $('.sidebar-body').slideDown()
        })
    }

    if (notificationButton && notificationContainer) {
        $(notificationButton).click(function (e) {
            e.stopPropagation()
            $(notificationContainer).slideToggle()
        })

        $(notificationContainer).click(function (e) {
            e.stopPropagation()
        })

        $(window).click(function() {
            $(notificationContainer).slideUp()
        })
    }

    if (basketButton && basketContainer) {
        $(basketButton).click(function (e) {
            document.initBasketCount();
            e.stopPropagation()
            $(basketContainer).slideToggle()
        })

        $(basketContainer).click(function (e) {
            e.stopPropagation()
        })

        $(window).click(function() {
            $(basketContainer).slideUp()
        })
    }


}

